/*eslint-disable*/
import Flickity from 'flickity'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default slider => {
  const flkty = new Flickity(slider, {
    wrapAround: true,
    cellAlign: 'left',
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true,
    percentPosition: false,
    autoPlay: 7000,
  })

  flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
  flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

  $(window).on('resize', () => flkty.resize())
  setTimeout(() => {
    flkty.resize()
  }, 1500)
}



// WEBPACK FOOTER //
// ./src/scripts/components/the-every-edit-featured-images.js